<script setup lang="ts" generic="T">
defineProps<{
  data?: Array<T>;
  message?: string;
}>();
</script>

<template>
  <div v-if="!data?.length" class="w-full h-full flex flex-col items-center justify-center text-secondary">
    <div class="text-center break-words hyphens-auto">{{ message || $t('general.noEntriesYet') }}</div>
    <slot />
  </div>
</template>
